export default {
  login: 'Jalalx',
  id: 1018975,
  node_id: 'MDQ6VXNlcjEwMTg5NzU=',
  avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/Jalalx',
  html_url: 'https://github.com/Jalalx',
  followers_url: 'https://api.github.com/users/Jalalx/followers',
  following_url: 'https://api.github.com/users/Jalalx/following{/other_user}',
  gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
  organizations_url: 'https://api.github.com/users/Jalalx/orgs',
  repos_url: 'https://api.github.com/users/Jalalx/repos',
  events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
  received_events_url: 'https://api.github.com/users/Jalalx/received_events',
  type: 'User',
  site_admin: false,
  name: 'Jalal Amini Robati',
  company: '@Bookingcom',
  blog: 'https://jalalamini.ir',
  location: 'Amsterdam, Netherlands',
  email: null,
  hireable: true,
  bio: 'Software Engineer',
  twitter_username: null,
  public_repos: 38,
  public_gists: 54,
  followers: 49,
  following: 94,
  created_at: '2011-09-01T09:00:01Z',
  updated_at: '2022-06-26T18:56:40Z',
};
